import fetchWrapper from "./fetchWrapper";

const getStorage = (useSessionStorage) => {
  let storage = null;
  try {
    storage = useSessionStorage ? window.sessionStorage : window.localStorage;
  } catch {
    storage = window.sessionStorage;
  }
  return storage;
};

export const removeLocalStorageKey = (key, useSessionStorage) => {
  const storage = getStorage(useSessionStorage);
  storage.removeItem(key);
};

const localStorageBackedLoad = async (url, key, useSessionStorage, fetchWrapperOptions = {}) => {
  let storage = getStorage(useSessionStorage);
  let json = storage.getItem(key);
  if (json === "loading") {
    let interval = null;
    return new Promise((resolve, reject) => {
      let checks = 0;
      interval = setInterval(() => {
        json = storage.getItem(key);
        checks++;
        try {
          if (json !== "loading" && json !== null && json !== undefined) {
            const waitedData = JSON.parse(json);
            clearInterval(interval);
            resolve(waitedData);
          }
          if (json === null || json === undefined) {
            clearInterval(interval);
            localStorageBackedLoad(url, key, useSessionStorage, fetchWrapperOptions)
              .then(resolve)
              .catch(reject);
            return;
          }
          if (checks > 20) {
            clearInterval(interval);
            storage.removeItem(key);
            reject(new Error("too many checks"));
          }
        } catch (e) {
          clearInterval(interval);
          storage.removeItem(key);
          reject(new Error(e));
        }
      }, 100);
    });
  } else if (json !== null && json !== undefined) {
    const localData = JSON.parse(json);
    return Promise.resolve(localData);
  } else {
    storage.setItem(key, "loading");
    let loadedSuccessfully = false;
    try {
      const loadedData = await fetchWrapper({ url, ...fetchWrapperOptions });
      const loadedAsJson = JSON.stringify(loadedData);
      storage.setItem(key, loadedAsJson);
      loadedSuccessfully = true;
      return loadedData;
    } finally {
      if (!loadedSuccessfully) {
        storage.removeItem(key);
      }
    }
  }
};

export default localStorageBackedLoad;
